/* Kaufschutz und Kaufbox-Verhalten (Viva Hayat, Brief 4.1 Punkte 3 bis 7).
   - Solange eine Option nicht aktiv gewählt wurde (Platzhalter "Bitte wählen" im
     versteckten Select), ist der Kaufen-Button deaktiviert und heißt "Größe wählen".
     Klick darauf (landet dank pointer-events:none auf dem Wrapper) scrollt sanft zum
     Größenraster und betont dessen Rahmen 300 ms.
   - Farb-Thumbnails (.vh-swatch) und Größenbuttons (.vh-size) setzen das jeweilige
     Select und feuern ein bubbelndes change-Event, damit variant-picker.js und
     product-form.js unverändert weiterlaufen.
   - Button-Texte: "Größe wählen" / "In den Warenkorb" / "Wird hinzugefügt" / "Hinzugefügt"
     (1200 ms). Nach cart:update erscheint die Bestätigungszeile
     "1 Artikel im Warenkorb. Zum Warenkorb ›" (Markup in snippets/vh-size-guide.liquid).
   - Galerie-Tausch bei unvollständiger Auswahl (nur Farbe) in document.startViewTransition.
   Funktioniert auf der Produktseite und im Quick-Add-Modal (MutationObserver). */
(function () {
  if (window.__vhVariantGuard) return;
  window.__vhVariantGuard = true;

  var ADDED_MS = 1200;
  var ATTENTION_MS = 300;
  var BUSY_TIMEOUT_MS = 8000;
  /* Texte in der Sprache der Seite (window.vhStrings aus layout/theme.liquid), Deutsch als Rueckfall */
  var T = window.vhStrings || {};
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var TXT_CHOOSE = T.chooseSize || 'Größe wählen';
  var TXT_ADD = T.addToCart || 'In den Warenkorb';
  var TXT_ADDING = T.adding || 'Wird hinzugefügt';
  var TXT_ADDED = T.added || 'Hinzugefügt';
  var TXT_PREORDER = T.preorder || 'Vorbestellen';
  var BUSY_TEXTS = [TXT_CHOOSE, TXT_ADDING, TXT_ADDED, TXT_PREORDER, T.soldOut || 'Ausverkauft'];

  function scopeOf(el) {
    return el.closest('dialog') || el.closest('.product-details') || document;
  }

  function emptySelects(scope) {
    return Array.prototype.filter.call(
      scope.querySelectorAll('.variant-option__select'),
      function (s) { return s.value === ''; }
    );
  }

  function isSizeSelect(s) {
    return /size|größe|groesse|grösse/i.test(s.getAttribute('name') || '');
  }

  function reducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function cssEscape(v) {
    return (window.CSS && CSS.escape) ? CSS.escape(v) : String(v).replace(/["\\]/g, '\\$&');
  }

  /* ---------- Button-Text ---------- */

  // Innerster Textknoten des Buttons (Horizon: .add-to-cart-text__content > span > span)
  function textNode(btn) {
    return btn.querySelector('.add-to-cart-text__content span span')
      || btn.querySelector('.add-to-cart-text__content span')
      || btn.querySelector('.add-to-cart-text__content');
  }

  function setText(btn, txt) {
    var n = textNode(btn);
    if (n && n.textContent.trim() !== txt) n.textContent = txt;
  }

  // Server-Text merken ("In den Warenkorb legen" wird zur Brief-Fassung "In den Warenkorb";
  // "Ausverkauft", "Nicht verfügbar", "Jetzt vorbestellen" bleiben wie sie sind)
  function rememberLabel(btn) {
    var n = textNode(btn);
    if (!n) return;
    var t = n.textContent.trim();
    if (!t || BUSY_TEXTS.indexOf(t) !== -1) return;
    if (/warenkorb/i.test(t)) t = TXT_ADD;
    btn.dataset.vhLabel = t;
  }

  function restoreLabel(btn) {
    if (btn.dataset.vhLabel) setText(btn, btn.dataset.vhLabel);
  }

  function isBusy(btn) {
    return btn.dataset.vhBusy === 'true';
  }

  function setState(btn, missing) {
    rememberLabel(btn);
    if (missing) {
      btn.setAttribute('disabled', '');
      btn.classList.add('vh-guard-disabled');
      if (!isBusy(btn)) {
        // Sind alle Größen ausverkauft, gibt es nichts zu wählen: "Ausverkauft" statt "Größe wählen"
        var sizes = scopeOf(btn).querySelectorAll('.vh-size');
        var allOut = sizes.length > 0 && Array.prototype.every.call(sizes, function (s) {
          return s.getAttribute('aria-disabled') === 'true';
        });
        setText(btn, allOut ? (T.soldOut || 'Ausverkauft') : TXT_CHOOSE);
      }
    } else {
      if (btn.classList.contains('vh-guard-disabled')) {
        btn.removeAttribute('disabled');
        btn.classList.remove('vh-guard-disabled');
      }
      if (!isBusy(btn)) restoreLabel(btn);
    }
  }

  /* ---------- Vorbestellung (snippets/variant-main-picker.liquid, .vh-preorder-note) ----------
     Gewählte Variante ohne Bestand, aber verkäuflich: Hinweis zeigen, Button „Vorbestellen“, Bestellnotiz
     („Lieferung: Vorbestellung: Lieferung bis …“) als Line-Item-Property, sichtbar in Kasse, Mail und Bestellung. */
  function preorderOn(scope, missing) {
    var note = scope.querySelector('.vh-preorder-note[data-vh-preorder]');
    var on = false;
    if (note && !missing) {
      var keys = [];
      try { keys = JSON.parse(note.getAttribute('data-vh-preorder') || '[]'); } catch (err) {}
      var vals = Array.prototype.map.call(scope.querySelectorAll('.variant-option__select'), function (s) { return s.value; });
      on = keys.indexOf(vals.join('/')) !== -1;
    }
    if (note) note.hidden = !on;
    scope.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      var prop = form.querySelector('input[data-vh-preorder-prop]');
      if (on && note) {
        if (!prop) {
          prop = document.createElement('input');
          prop.type = 'hidden';
          prop.setAttribute('data-vh-preorder-prop', '');
          form.appendChild(prop);
        }
        prop.name = 'properties[' + note.getAttribute('data-vh-preorder-prop') + ']';
        prop.value = note.getAttribute('data-vh-preorder-text') || '';
      } else if (prop) {
        prop.remove();
      }
    });
    return on;
  }

  function ensureAll() {
    // Pro Button den eigenen Kontext bewerten (deckt auch Sticky-Bar und Quick-Add-Modal ab)
    document.querySelectorAll('.add-to-cart-button').forEach(function (b) {
      var scope = scopeOf(b);
      var missing = emptySelects(scope).length > 0;
      setState(b, missing);
      if (preorderOn(scope, missing) && !isBusy(b)) setText(b, TXT_PREORDER);
    });
    document.querySelectorAll('.vh-choose-hint').forEach(function (h) {
      if (!emptySelects(scopeOf(h)).length) h.remove();
    });
  }

  /* ---------- Auswahl-Zustand der Thumbnails und Größenbuttons ---------- */

  function syncButtons(optWrap, value) {
    optWrap.querySelectorAll('.vh-swatch, .vh-size').forEach(function (b) {
      if (b.hasAttribute('data-vh-family-url')) return; /* Farbfamilie: Auswahl kommt aus dem Liquid (snippets/variant-main-picker.liquid) */
      var v = b.getAttribute('data-vh-swatch-value');
      if (v === null) v = b.getAttribute('data-vh-size-value');
      var on = value !== '' && v === value;
      b.classList.toggle('is-selected', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function setLabelValue(optWrap, select) {
    var labelValue = optWrap.querySelector('.vh-opt-value');
    if (!labelValue) return;
    /* Farbfamilie: Label ist der eigene Farbname des Produkts, nicht der Wert des versteckten Selects ("White") */
    var fam = optWrap.querySelector('.vh-swatch[data-vh-family-url].is-selected');
    if (fam) {
      labelValue.textContent = fam.getAttribute('data-vh-swatch-label') || '';
      return;
    }
    if (!select.value) {
      labelValue.textContent = '';
      return;
    }
    var sw = optWrap.querySelector('.vh-swatch[data-vh-swatch-value="' + cssEscape(select.value) + '"]');
    labelValue.textContent = (sw && sw.getAttribute('data-vh-swatch-label')) || select.value;
  }

  // Gemeinsamer Weg fuer Thumbnail und Größenbutton: Select setzen, change feuern
  function chooseValue(btn, value) {
    if (btn.getAttribute('aria-disabled') === 'true') return;
    var opt = btn.closest('.variant-option');
    var select = opt && opt.querySelector('.variant-option__select');
    if (!select || value === null) return;
    if (select.value === value) return;
    select.value = value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var sw = e.target.closest('.vh-swatch');
    if (sw) {
      chooseValue(sw, sw.getAttribute('data-vh-swatch-value'));
      return;
    }
    var sz = e.target.closest('.vh-size');
    if (sz) chooseValue(sz, sz.getAttribute('data-vh-size-value'));
  });

  /* ---------- "Größe wählen": zum Raster scrollen, Rahmen 300 ms betonen ---------- */

  function attention(sizes) {
    try {
      sizes.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'nearest' });
    } catch (err) {
      sizes.scrollIntoView();
    }
    sizes.classList.add('vh-sizes--attention');
    clearTimeout(sizes.__vhAttention);
    sizes.__vhAttention = setTimeout(function () {
      sizes.classList.remove('vh-sizes--attention');
    }, ATTENTION_MS);
  }

  // Fallback ohne Größenraster (Quick-Add-Modal mit Dropdowns): Hinweistext
  function showHint(scope) {
    var empty = emptySelects(scope);
    empty.forEach(function (s) { s.classList.add('vh-choose-missing'); });
    var picker = scope.querySelector('variant-picker');
    if (picker && !scope.querySelector('.vh-choose-hint')) {
      var onlySize = empty.length > 0 && empty.every(isSizeSelect);
      var p = document.createElement('p');
      p.className = 'vh-choose-hint';
      p.textContent = onlySize ? (T.chooseSizeFirst || 'Bitte wähle zuerst eine Größe.') : (T.chooseBothFirst || 'Bitte wähle zuerst Farbe und Größe.');
      picker.insertAdjacentElement('afterend', p);
    }
  }

  function nudge(scope) {
    var sizes = scope.querySelector('.vh-sizes');
    if (sizes && sizes.offsetParent !== null) { attention(sizes); return; }
    /* Handy: das Größenraster ist ausgeblendet, gewählt wird im Dropdown. Dorthin scrollen und es fokussieren,
       sonst gab „Größe wählen“ am Handy keine Rückmeldung (Review 25.10.2026) */
    var empty = emptySelects(scope);
    var sel = empty.filter(isSizeSelect)[0] || empty[0];
    if (sel && sel.offsetParent !== null) {
      try { sel.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'center' }); } catch (err) { sel.scrollIntoView(); }
      try { sel.focus({ preventScroll: true }); } catch (err) { sel.focus(); }
      return;
    }
    showHint(scope);
  }

  // Klick auf den deaktivierten Button trifft dank pointer-events:none den Wrapper
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var zone = e.target.closest('.buy-buttons-block, product-form-component, .sticky-add-to-cart, sticky-add-to-cart');
    if (!zone) return;
    var scope = scopeOf(zone);
    if (emptySelects(scope).length) nudge(scope);
  });

  // Sicherheitsnetz: kein Submit, solange nichts gewählt ist (z.B. per Tastatur);
  // sonst Button auf "Wird hinzugefügt"
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.closest) return;
    /* Nur Kaufformulare prüfen. Vorher sperrte eine offene Größenwahl auf der Produktseite auch andere Formulare,
       z. B. „Weiter zur Zahlung“ im Warenkorb-Overlay (Review 25.10.2026) */
    var isProductForm = form.closest('product-form-component') || /\/cart\/add/.test(form.getAttribute('action') || '');
    if (!isProductForm) return;
    var scope = scopeOf(form);
    if (emptySelects(scope).length) {
      e.preventDefault();
      e.stopImmediatePropagation();
      nudge(scope);
      return;
    }
    if (!form.closest('product-form-component')) return;
    scope.querySelectorAll('.add-to-cart-button').forEach(function (b) {
      rememberLabel(b);
      b.dataset.vhBusy = 'true';
      setText(b, TXT_ADDING);
      // Sicherheitsnetz: scheitert der Fetch in product-form.js technisch (Netz, Timeout, kein JSON),
      // feuert weder cart:update noch cart:error; der Button bliebe sonst dauerhaft auf "Wird hinzugefügt"
      clearTimeout(b.__vhBusyTimer);
      b.__vhBusyTimer = setTimeout(function () {
        var n = textNode(b);
        if (b.dataset.vhBusy === 'true' && n && n.textContent.trim() === TXT_ADDING) {
          delete b.dataset.vhBusy;
          restoreLabel(b);
          ensureAll();
        }
      }, BUSY_TIMEOUT_MS);
    });
  }, true);

  /* ---------- Nach dem Hinzufügen: "Hinzugefügt" 1200 ms, Bestätigungszeile ---------- */

  function releaseButtons(scope) {
    scope.querySelectorAll('.add-to-cart-button').forEach(function (b) {
      clearTimeout(b.__vhAddedTimer);
      clearTimeout(b.__vhBusyTimer);
      delete b.dataset.vhBusy;
      restoreLabel(b);
    });
    ensureAll();
  }

  function showCartLine(scope, detail) {
    var line = scope.querySelector('[data-vh-cartline]') || document.querySelector('main [data-vh-cartline]');
    if (!line) return;
    var countEl = line.querySelector('[data-vh-cart-count]');
    var apply = function (n) {
      if (countEl && typeof n === 'number' && !isNaN(n)) countEl.textContent = String(n);
      line.hidden = false;
    };
    var res = detail && detail.resource;
    if (res && typeof res.item_count === 'number') {
      apply(res.item_count);
      return;
    }
    // detail.data.itemCount ist nur die hinzugefügte Menge, deshalb den Stand frisch holen
    fetch(ROOT + 'cart.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (c) { apply(c.item_count); })
      .catch(function () { apply(NaN); });
  }

  document.addEventListener('cart:update', function (e) {
    var d = (e && e.detail) || {};
    var data = d.data || {};
    if (data.source !== 'product-form-component') return;
    var formComponent = e.target && e.target.closest ? e.target.closest('product-form-component') : null;
    var scope = formComponent ? scopeOf(formComponent) : document;
    if (data.didError) {
      releaseButtons(scope);
      return;
    }
    scope.querySelectorAll('.add-to-cart-button').forEach(function (b) {
      rememberLabel(b);
      b.dataset.vhBusy = 'true';
      setText(b, TXT_ADDED);
      clearTimeout(b.__vhBusyTimer);
      clearTimeout(b.__vhAddedTimer);
      b.__vhAddedTimer = setTimeout(function () {
        delete b.dataset.vhBusy;
        restoreLabel(b);
        ensureAll();
      }, ADDED_MS);
    });
    showCartLine(scope, d);
  });

  document.addEventListener('cart:error', function (e) {
    var formComponent = e.target && e.target.closest ? e.target.closest('product-form-component') : null;
    releaseButtons(formComponent ? scopeOf(formComponent) : document);
  });

  /* ---------- Variantenwechsel ---------- */

  document.addEventListener('change', function (e) {
    if (!e.target || !e.target.matches || !e.target.matches('.variant-option__select')) return;
    var select = e.target;
    if (select.value !== '') select.classList.remove('vh-choose-missing');
    var optWrap = select.closest('.variant-option');
    if (optWrap) {
      setLabelValue(optWrap, select);
      syncButtons(optWrap, select.value);
    }
    var scope = scopeOf(select);
    ensureAll();
    maybeSwapGalleryImage(select, scope);
  });

  // product-form.js morpht den Button nach dem Variantenwechsel (Server-Text), danach Zustand neu setzen
  document.addEventListener('variant:update', function () { ensureAll(); });

  /* Bei unvollständiger Auswahl (z.B. nur Farbe gewählt) macht die
     Theme-Pipeline nichts, das Produktbild bliebe falsch. Wir holen die Seite
     der zugehörigen Variante und tauschen nur die Galerie aus, exakt so, wie
     es media-gallery.js bei einem vollständigen Variantenwechsel selbst tut. */
  function swapGallery(current, fresh) {
    var doSwap = function () {
      current.replaceWith(document.importNode(fresh, true));
    };
    // Same-Document View Transition: die Hero-Box (view-transition-name vh-hero) blendet 250 ms
    if (typeof document.startViewTransition === 'function' && !reducedMotion()) {
      try {
        var vt = document.startViewTransition(doSwap);
        if (vt && vt.ready && vt.ready.catch) vt.ready.catch(function () {});
        return;
      } catch (err) { /* faellt auf den direkten Tausch zurueck */ }
    }
    doSwap();
  }

  function maybeSwapGalleryImage(select, scope) {
    if (select.value === '') return;
    // Nur die Farbe steuert das Bild. Größe (aus dem Berater gesetzt) darf die
    // Galerie nicht verstellen, sonst springt das Bild bei Größenwahl.
    var oname = (select.getAttribute('name') || '').toLowerCase();
    if (oname.indexOf('color') === -1 && oname.indexOf('colour') === -1 && oname.indexOf('farbe') === -1) return;
    if (!emptySelects(scope).length) return; // vollständig: Theme übernimmt
    var opt = select.options[select.selectedIndex];
    var vid = opt && opt.dataset ? opt.dataset.variantId : null;
    if (!vid) return;
    var picker = select.closest('variant-picker');
    var onProductPage = /^(\/[a-z]{2}(-[a-z]{2})?)?\/products\//i.test(location.pathname); /* auch /en/products/... */
    var purl = (picker && picker.dataset.productUrl) || (onProductPage ? location.pathname : null);
    if (!purl) return;
    // URL aktualisieren (Brief 4.1 "Farbwechsel"): Horizons replaceState entfällt hier, weil
    // variant-picker.js am Platzhalter-Option ohne data-option-value-id abbricht ("No option value ID
    // found" in der Konsole ist bekannt und beabsichtigt, Kern bleibt unangetastet). Nur auf der
    // eigenen Produktseite, nicht für ein Quick-Add-Produkt.
    if (onProductPage && purl.split('?')[0] === location.pathname) {
      try {
        var u = new URL(location.href);
        u.searchParams.set('variant', vid);
        if (u.href !== location.href) history.replaceState(history.state, '', u.toString());
      } catch (err) { /* URL bleibt wie sie ist */ }
    }
    // Galerie liegt NEBEN .product-details im Grid, deshalb weiter oben suchen
    var galleryScope = select.closest('dialog') || select.closest('.product-information') || document;
    fetch(purl.split('?')[0] + '?variant=' + vid)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('media-gallery');
        var current = galleryScope.querySelector('media-gallery');
        if (!fresh || !current) return;
        // Bild-ID der Variante mitgeben, damit media-gallery.js beim nächsten
        // Variantenwechsel korrekt vergleichen kann (verhindert ein unnötiges
        // Neuladen beim ersten Größenwechsel nach der Farbwahl)
        try {
          var vjson = JSON.parse(doc.querySelector('variant-picker script[type="application/json"]').textContent);
          if (vjson && vjson.featured_media) fresh.dataset.vhMediaId = String(vjson.featured_media.id);
        } catch (err) { /* Vergleich fällt dann auf den DOM-Fallback zurück */ }
        swapGallery(current, fresh);
      })
      .catch(function () {});
  }

  /* ---------- Keine Größen-Vorauswahl (Brief 4.1 Punkt 4) ----------
     Kommt die Seite mit ?variant= (Farbkreis auf der Startseite), rendert Shopify auch die
     Größe dieser Variante vorgewählt. Zurück auf den Platzhalter, Farbe bleibt. Der Guard
     sperrt den Button, bis eine Größe gewählt ist; die Wahl löst den normalen Fetch aus. */
  function resetSizePreselection(root, force) {
    /* force: Produkt-Overlay (assets/vh-transitions.js) meldet sich nach dem Einhaengen, die Adresse
       bleibt dort auf der Startseite, deshalb kein ?variant= in location.search */
    if (!force && !/[?&]variant=/.test(location.search)) return;
    var base = root || document;
    var sel = root ? '.product-details .variant-option__select' : 'main[data-template="product"] .product-details .variant-option__select';
    base.querySelectorAll(sel).forEach(function (s) {
      if (!isSizeSelect(s)) return;
      var placeholder = s.querySelector('option[value=""]');
      if (!placeholder) return;
      Array.prototype.forEach.call(s.options, function (o) { o.removeAttribute('selected'); });
      placeholder.setAttribute('selected', 'selected');
      s.value = '';
      var optWrap = s.closest('.variant-option');
      if (optWrap) {
        setLabelValue(optWrap, s);
        syncButtons(optWrap, '');
      }
    });
  }

  // Quick-Add-Modal injiziert Inhalte nachträglich
  var mo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      for (var j = 0; j < muts[i].addedNodes.length; j++) {
        var n = muts[i].addedNodes[j];
        if (n.nodeType === 1 && n.querySelector && (n.querySelector('.variant-option__select') || n.matches('.variant-option__select'))) {
          ensureAll();
          return;
        }
      }
    }
  });

  /* Produkt-Overlay eingehaengt: keine Groessen-Vorauswahl, Button gesperrt bis zur Wahl (Cano: "Vorwahl XS weg") */
  document.addEventListener('vh:product-mounted', function (e) {
    var root = e && e.detail && e.detail.root;
    if (!root) return;
    /* Länderwechsel mit gewählter Größe (assets/vh-transitions.js, keepSize): Größe stehen lassen */
    if (!e.detail.keepSize) resetSizePreselection(root, true);
    ensureAll();
  });

  function init() {
    resetSizePreselection();
    ensureAll();
    mo.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
